// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 2: L'ESODO
// ============================================================================
// Livelli 14-26 (13 livelli, 39 domande)

export const chapter2Translations = {
  name: "L'Esodo",
  description: "La liberazione del popolo di Dio... Conoscere Dio trasforma le nostre vite",
  
  spiritualWisdom: {
    principle: "La conoscenza di Dio libera e trasforma",
    scripture: "Conoscerete la verità e la verità vi farà liberi (Giovanni 8:32)",
    application: "Come Israele fu liberato dall'Egitto, la conoscenza di Dio ci libera dalla schiavitù spirituale"
  },
  
  levels: {
    14: {
      name: "Mosè Salvato dalle Acque",
      challenge: "La donna concepì e partorì un figlio. Vedendo che era bello...",
      easy: {
        question: "In cosa nascose la madre di Mosè suo figlio?",
        options: ["Una grotta", "Una cesta di giunchi", "Un cesto", "Una casa"],
        hint: "Questo recipiente galleggiava sul Nilo",
        funFact: "🏺 La cesta di giunchi era rivestita di bitume per essere impermeabile!"
      },
      medium: {
        question: "Chi trovò Mosè tra i giunchi?",
        options: [
          "La figlia del Faraone",
          "Una serva egiziana",
          "Sua sorella Miriam",
          "Un sacerdote egiziano"
        ],
        hint: "Un membro della famiglia reale egiziana",
        funFact: "👑 Ironicamente, è la famiglia del Faraone che salva colui che lo sfiderà!"
      },
      hard: {
        question: "Come utilizza la Provvidenza divina anche i nostri nemici?",
        options: [
          "Convertendoli",
          "Orchestrando le circostanze per compiere i suoi disegni",
          "Punendoli",
          "Ignorandoli"
        ],
        hint: "Si tratta di vedere la mano di Dio negli eventi",
        funFact: "✨ Mosè crebbe nel palazzo di colui che opprimeva il suo popolo!"
      }
    },
    
    15: {
      name: "Il Roveto Ardente",
      challenge: "L'angelo del Signore gli apparve in una fiamma di fuoco...",
      easy: {
        question: "Cosa doveva togliersi Mosè davanti al roveto ardente?",
        options: ["I suoi gioielli", "I suoi sandali", "Il suo mantello", "Il suo turbante"],
        hint: "Ciò che si indossa ai piedi",
        funFact: "👡 Togliersi le scarpe esprime rispetto su terra santa!"
      },
      medium: {
        question: "Quale nome rivela Dio a Mosè?",
        options: [
          "Il Signore",
          "IO SONO COLUI CHE SONO",
          "L'Onnipotente",
          "Il Creatore"
        ],
        hint: "Un nome che esprime l'esistenza assoluta",
        funFact: "🔥 YHWH (Io Sono) rivela l'essenza eterna di Dio!"
      },
      hard: {
        question: "Cosa ci insegna il roveto che brucia senza consumarsi?",
        options: [
          "La magia esiste",
          "Dio trascende le leggi naturali",
          "Il fuoco è sacro",
          "Le piante sono magiche"
        ],
        hint: "Si tratta della natura divina che supera la nostra comprensione",
        funFact: "🌿 Il roveto simboleggia che la presenza divina santifica senza distruggere!"
      }
    },

    16: {
      name: "Le Dieci Piaghe d'Egitto",
      challenge: "Il Faraone indurì il suo cuore e non li ascoltò...",
      easy: {
        question: "Qual fu la prima piaga d'Egitto?",
        options: ["Le rane", "L'acqua trasformata in sangue", "Le mosche", "I pidocchi"],
        hint: "Colpì il Nilo, fonte di vita per l'Egitto",
        funFact: "🩸 Il Nilo era adorato come un dio, e Dio mostrò la sua superiorità!"
      },
      medium: {
        question: "Qual fu l'ultima e più terribile delle piaghe?",
        options: [
          "La grandine",
          "Le tenebre",
          "La morte dei primogeniti",
          "Le locuste"
        ],
        hint: "Questa piaga colpì direttamente le famiglie",
        funFact: "😢 Questa piaga spezzò finalmente l'orgoglio del Faraone e liberò Israele!"
      },
      hard: {
        question: "Perché Dio indurisce il cuore del Faraone?",
        options: [
          "Per punirlo",
          "Per manifestare la sua gloria e potenza",
          "Per cattiveria",
          "Per prolungare le sofferenze"
        ],
        hint: "Si tratta di rivelare chi è il vero Dio",
        funFact: "⚡ Le piaghe dimostrano che YHWH è più potente di tutti gli dei egiziani!"
      }
    },

    17: {
      name: "La Pasqua",
      challenge: "Prendete un agnello... e metterete del suo sangue sugli stipiti...",
      easy: {
        question: "Dove dovevano mettere gli israeliti il sangue dell'agnello?",
        options: [
          "Sui loro vestiti",
          "Sugli stipiti e architravi delle porte",
          "Sulle loro fronti",
          "In coppe"
        ],
        hint: "All'ingresso delle loro case",
        funFact: "🩸 Il sangue sulla porta era il segno della protezione divina!"
      },
      medium: {
        question: "Come dovevano mangiare l'agnello pasquale?",
        options: [
          "Seduti comodamente",
          "Solo in famiglia",
          "Con i fianchi cinti, sandali ai piedi, bastone in mano",
          "In silenzio"
        ],
        hint: "Pronti per la partenza",
        funFact: "🚶 Dovevano essere pronti a partire rapidamente verso la libertà!"
      },
      hard: {
        question: "Come l'Agnello pasquale prefigura Cristo?",
        options: [
          "Per il suo colore bianco",
          "Per il suo sacrificio sostitutivo che salva dalla morte",
          "Per la sua mitezza",
          "Per la sua età"
        ],
        hint: "Si tratta del sacrificio che libera dalla condanna",
        funFact: "🐑 Gesù è chiamato 'l'Agnello di Dio che toglie il peccato del mondo'!"
      }
    },

    18: {
      name: "L'Attraversamento del Mar Rosso",
      challenge: "Mosè stese la sua mano sul mare...",
      easy: {
        question: "Come attraversarono gli israeliti il mare?",
        options: [
          "In barca",
          "Nuotando",
          "All'asciutto",
          "Su una zattera"
        ],
        hint: "Il fondo del mare era praticabile",
        funFact: "🌊 Dio trasformò un ostacolo in via di liberazione!"
      },
      medium: {
        question: "Cosa accadde agli egiziani che inseguivano?",
        options: [
          "Tornarono indietro",
          "Furono inghiottiti dalle acque",
          "Si persero",
          "Si unirono a Israele"
        ],
        hint: "Le acque tornarono su di loro",
        funFact: "⚔️ L'esercito più potente del mondo fu distrutto in un istante!"
      },
      hard: {
        question: "Cosa simboleggia questo attraversamento nella nostra vita spirituale?",
        options: [
          "La fuga dai problemi",
          "Il passaggio dalla schiavitù del peccato alla libertà in Dio",
          "La superiorità di Israele",
          "La distruzione dei nemici"
        ],
        hint: "Si tratta di una trasformazione spirituale",
        funFact: "🗽 Il Mar Rosso rappresenta il battesimo: morte al vecchio, vita nuova!"
      }
    },

    19: {
      name: "La Manna nel Deserto",
      challenge: "Cos'è questo? Perché non sapevano cos'era...",
      easy: {
        question: "Per quanto tempo cadde la manna?",
        options: ["10 anni", "20 anni", "40 anni", "50 anni"],
        hint: "Lo stesso numero degli anni nel deserto",
        funFact: "🍞 Per 40 anni, Dio nutrì miracolosamente 2 milioni di persone!"
      },
      medium: {
        question: "Cosa succedeva se conservavano la manna più di un giorno?",
        options: [
          "Diventava più gustosa",
          "Si moltiplicava",
          "Marciva e puzzava",
          "Si induriva"
        ],
        hint: "Tranne il venerdì per il sabato",
        funFact: "🪱 Dio insegnava così la dipendenza quotidiana da Lui!"
      },
      hard: {
        question: "Come la manna ci insegna la fiducia?",
        options: [
          "Accumulando per il futuro",
          "Contando sulla provvidenza quotidiana di Dio",
          "Lavorando più duramente",
          "Condividendo equamente"
        ],
        hint: "Si tratta di fidarsi giorno per giorno",
        funFact: "🙏 'Dacci oggi il nostro pane quotidiano' viene da questa esperienza!"
      }
    },

    20: {
      name: "L'Acqua dalla Roccia",
      challenge: "Colpirai la roccia, e ne uscirà acqua...",
      easy: {
        question: "Con cosa doveva Mosè colpire la roccia?",
        options: ["La sua mano", "La sua verga", "Una pietra", "Un martello"],
        hint: "Lo strumento dei miracoli di Mosè",
        funFact: "⚡ La verga di Mosè era lo strumento della potenza divina!"
      },
      medium: {
        question: "Perché il popolo mormorava contro Mosè?",
        options: [
          "Non c'era acqua da bere",
          "Mancava il cibo",
          "Il cammino era troppo lungo",
          "Faceva troppo caldo"
        ],
        hint: "Un bisogno vitale nel deserto",
        funFact: "💧 L'acqua è più essenziale del cibo per la sopravvivenza!"
      },
      hard: {
        question: "Cosa rappresenta spiritualmente l'acqua dalla roccia?",
        options: [
          "Le risorse naturali",
          "La vita spirituale che sgorga da Cristo, la Roccia",
          "La ricompensa degli sforzi",
          "La magia divina"
        ],
        hint: "Paolo dice che quella roccia era Cristo",
        funFact: "🗿 Cristo è la Roccia colpita dalla quale sgorga la vita eterna!"
      }
    },

    21: {
      name: "Il Monte Sinai",
      challenge: "Tutto il monte Sinai fumava, perché il Signore vi era disceso...",
      easy: {
        question: "Quanti comandamenti ha dato Dio?",
        options: ["5", "7", "10", "12"],
        hint: "Un numero tondo e perfetto",
        funFact: "📜 I Dieci Comandamenti sono il fondamento morale dell'umanità!"
      },
      medium: {
        question: "Su cosa erano scritti i comandamenti?",
        options: [
          "Papiro",
          "Pergamena",
          "Due tavole di pietra",
          "Bronzo"
        ],
        hint: "Un materiale durevole scritto dal dito di Dio",
        funFact: "✍️ Scritti da Dio stesso per mostrare la loro importanza eterna!"
      },
      hard: {
        question: "Qual è lo scopo dei comandamenti divini?",
        options: [
          "Punire gli uomini",
          "Rivelare la santità di Dio e guidare verso la felicità",
          "Creare regole complesse",
          "Separare i popoli"
        ],
        hint: "Si tratta di rivelare il carattere divino e la via del bene",
        funFact: "⚖️ I comandamenti rivelano l'amore: amore di Dio e del prossimo!"
      }
    },

    22: {
      name: "Il Vitello d'Oro",
      challenge: "Facci un dio che cammini davanti a noi...",
      easy: {
        question: "Con cosa fece Aronne il vitello d'oro?",
        options: [
          "Monete d'oro",
          "Gli orecchini d'oro del popolo",
          "Gioielli preziosi",
          "Oro del deserto"
        ],
        hint: "Gioielli personali donati dal popolo",
        funFact: "👂 Il popolo diede i suoi gioielli per creare il proprio idolo!"
      },
      medium: {
        question: "Quale fu la reazione di Mosè vedendo il vitello?",
        options: [
          "Pianse",
          "Pregò",
          "Spezzò le tavole della legge",
          "Si arrabbiò soltanto"
        ],
        hint: "Un gesto simbolico dell'alleanza infranta",
        funFact: "💥 Spezzare le tavole simboleggiava che l'alleanza era rotta!"
      },
      hard: {
        question: "Perché l'idolatria è così pericolosa spiritualmente?",
        options: [
          "Costa cara",
          "Distoglie il cuore dal vero Dio verso le creature",
          "Divide le famiglie",
          "È vietata"
        ],
        hint: "Si tratta di dare alla creatura ciò che spetta al Creatore",
        funFact: "💔 L'idolatria spezza la relazione esclusiva con il Dio vivente!"
      }
    },

    23: {
      name: "Il Tabernacolo",
      challenge: "Mi faranno un santuario, e io abiterò in mezzo a loro...",
      easy: {
        question: "Come si chiamava la tenda sacra degli israeliti?",
        options: ["Il Tempio", "Il Tabernacolo", "Il Santuario", "L'Arca"],
        hint: "Il nome significa 'tenda dell'incontro'",
        funFact: "⛺ Il Tabernacolo era la 'casa mobile' di Dio con il suo popolo!"
      },
      medium: {
        question: "Cosa conteneva l'Arca dell'Alleanza?",
        options: [
          "I gioielli del sommo sacerdote",
          "Le tavole della legge, la manna, la verga di Aronne",
          "Monete d'oro",
          "I rotoli della Torah"
        ],
        hint: "Tre oggetti che simboleggiano l'alleanza con Dio",
        funFact: "📦 L'Arca conteneva i 'ricordi' della fedeltà divina!"
      },
      hard: {
        question: "Cosa simboleggia il Tabernacolo nella nostra relazione con Dio?",
        options: [
          "Un edificio religioso",
          "La presenza di Dio che abita tra noi e in noi",
          "Un luogo solo di sacrificio",
          "Un simbolo nazionale"
        ],
        hint: "Si tratta della presenza divina accessibile",
        funFact: "🏠 'Il vostro corpo è tempio dello Spirito Santo' secondo Paolo!"
      }
    },

    24: {
      name: "Il Sommo Sacerdote Aronne",
      challenge: "Consacrerai Aronne e i suoi figli perché siano miei sacerdoti...",
      easy: {
        question: "Chi fu il primo sommo sacerdote d'Israele?",
        options: ["Mosè", "Aronne", "Giosuè", "Eleazaro"],
        hint: "Il fratello di Mosè",
        funFact: "👨‍⚕️ Aronne fondò la stirpe sacerdotale che durò più di 1000 anni!"
      },
      medium: {
        question: "Cosa portava il sommo sacerdote sul petto?",
        options: [
          "Una croce d'oro",
          "Il pettorale con le dodici pietre preziose",
          "Un medaglione",
          "Una catena d'oro"
        ],
        hint: "Dodici pietre che rappresentano le dodici tribù",
        funFact: "💎 Il sommo sacerdote portava simbolicamente tutto Israele sul suo cuore!"
      },
      hard: {
        question: "Come Gesù compie il ruolo di Sommo Sacerdote?",
        options: [
          "Indossando vesti sacre",
          "Offrendo il proprio sangue una volta per sempre",
          "Servendo nel Tempio",
          "Discendendo da Aronne"
        ],
        hint: "Si tratta di un sacrificio perfetto e definitivo",
        funFact: "✝️ Gesù è Sommo Sacerdote eterno secondo l'ordine di Melchisedek!"
      }
    },

    25: {
      name: "I Sacrifici",
      challenge: "Se qualcuno di voi offre un'offerta al Signore...",
      easy: {
        question: "Qual era il sacrificio quotidiano nel Tabernacolo?",
        options: [
          "Il sacrificio di pace",
          "L'olocausto del mattino e della sera",
          "Il sacrificio per il peccato",
          "L'offerta di focacce"
        ],
        hint: "Due volte al giorno, mattina e sera",
        funFact: "🔥 Il fuoco sull'altare non doveva mai spegnersi!"
      },
      medium: {
        question: "Cosa simboleggiava l'imposizione delle mani sull'animale?",
        options: [
          "La benedizione",
          "Il trasferimento dei peccati sulla vittima",
          "L'affetto per l'animale",
          "La consacrazione"
        ],
        hint: "Un gesto di sostituzione",
        funFact: "🤲 L'animale moriva al posto del peccatore - principio di sostituzione!"
      },
      hard: {
        question: "Come questi sacrifici prefigurano l'opera di Cristo?",
        options: [
          "Per il loro numero",
          "Per la sostituzione: l'innocente muore per il colpevole",
          "Per il loro costo",
          "Per la loro bellezza"
        ],
        hint: "Si tratta del principio dell'innocente che prende il posto del colpevole",
        funFact: "🐑 'È stato trafitto per i nostri peccati, schiacciato per le nostre iniquità'!"
      }
    },

    26: {
      name: "Ai Confini della Terra Promessa",
      challenge: "Manderò davanti a te un angelo, e scaccerò i Cananei...",
      easy: {
        question: "Quante spie furono inviate per esplorare la Terra Promessa?",
        options: ["10", "12", "20", "40"],
        hint: "Una per tribù d'Israele",
        funFact: "🕵️ Solo 2 delle 12 spie fecero un rapporto incoraggiante!"
      },
      medium: {
        question: "Quali spie incoraggiarono il popolo a entrare nella terra?",
        options: [
          "Aronne e Mosè",
          "Giosuè e Caleb",
          "Gad e Aser",
          "Ruben e Simeone"
        ],
        hint: "Due uomini di fede che videro le promesse di Dio",
        funFact: "🦁 Giosuè e Caleb furono gli unici della loro generazione a entrare in Canaan!"
      },
      hard: {
        question: "Perché Israele vagò 40 anni nel deserto?",
        options: [
          "Per punirli",
          "A causa della loro incredulità di fronte alle promesse divine",
          "Per addestrarli al combattimento",
          "Per trovare la strada giusta"
        ],
        hint: "Si tratta di mancanza di fiducia in Dio",
        funFact: "🏜️ Un'intera generazione dovette morire a causa dell'incredulità!"
      }
    }
  }
};

export default chapter2Translations;
